import { Component, Input, OnInit } from '@angular/core';
@Component({
    selector: 'simple-icons-gitlfs',
    template: `<svg class="simple-icons {{ className }}" [style.width]="size" [style.height]="size" [style.fill]="color" role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><title>Git LFS icon</title><path d="M11.967.304L0 7.215v9.68l11.79 6.802V14.02l11.96-6.91-4.383-2.53-11.959 6.905v3.887l-2.775-1.601V9.886l11.965-6.91zM24 7.545L12.29 14.31v9.387L24 16.929V7.547z"/></svg>`,
    styles: []
})
export class SimpleIconsGitlfsComponent implements OnInit {
    @Input() size: string = '100%';
    @Input() color: string = '#F64935';
    @Input() className: string = 'simple-icons-gitlfs'
    constructor() {}
    ngOnInit(): void {}
}
